// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"385":"c87a39ec","512":"1b42d3a6","669":"52568682","868":"a8252914"}[chunkId] + ".chunk.css";
};